module.exports = __webpack_public_path__ + "img/pinata-banner-a.3c3b192d.jpg";